import React from "react";
import Modal from "@mui/material/Modal";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AmsterModal = ({ open, onClose }) => (
  <Modal open={open} onClose={onClose} BackdropProps={{ style: { backgroundColor: "rgba(0,0,0,0.4)" } }}>
    <Box
      onClick={e => e.stopPropagation()}
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "background.paper",
        borderRadius: 4,
        boxShadow: 24,
        p: 4,
        minWidth: 320,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        outline: "none",
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 12,
          right: 12,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <Box
        component="img"
        src="/amster.jpg"
        alt="Amster"
        sx={{ width: 120, height: 120, borderRadius: "50%", mb: 2, objectFit: "cover" }}
      />
      <Typography
        variant="h5"
        sx={{ fontFamily: "Monument-Private", fontWeight: 600 }}
      >
        Ready to book?
      </Typography>
      <Typography
        variant="body1"
        sx={{ textAlign: "center", mb: 3, color: "text.secondary" }}>
            Book this experience with Amster
        </Typography>
      <Button
        variant="contained"
        color="primary"
        href="tel:+918668585545"
        startIcon={<span role="img" aria-label="phone">📞</span>}
        sx={{ borderRadius: 3, fontWeight: 600, fontSize: "1.1rem", px: 4 }}
      >
        Call now
      </Button>
    </Box>
  </Modal>
);

export default AmsterModal;
